module.exports = __webpack_public_path__ + "static/values-38b58419eb705ea929448b63a9ed2789.png";